module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/alerts/alerts.component.scss
// module id = 577
// module chunks = 1